import { labelChipStyle, safeLabelColor } from '../utils/label-color';

export interface ChipLabel {
  id: string;
  name: string;
  color: string;
}

interface LabelChipsProps {
  options: readonly ChipLabel[];
  selectedIds: readonly string[];
  onToggle?: (labelId: string) => void;
  pending?: boolean;
}

export default function LabelChips({
  options,
  selectedIds,
  onToggle,
  pending = false,
}: LabelChipsProps) {
  return (
    <div className="rsv-chip-row" style={pending ? { opacity: 0.6 } : undefined}>
      {options.map((label) => {
        const on = selectedIds.includes(label.id);
        return (
          <button
            type="button"
            key={label.id}
            className="rsv-chip"
            style={{
              ...labelChipStyle(label.color, on),
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              cursor: onToggle ? 'pointer' : 'default',
            }}
            disabled={!onToggle}
            onClick={onToggle ? () => onToggle(label.id) : undefined}
          >
            {!on && (
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: safeLabelColor(label.color),
                  flex: '0 0 auto',
                }}
              />
            )}
            {label.name}
          </button>
        );
      })}
    </div>
  );
}
